<template>
  <div class="section" id="myPage">
    <div class="menu">
      <div class="column">
        <div class="columns is-align-items-center">
          <div class="column header">マイページ</div>
        </div>
        <div class="sectionwrap top">
          <div class="columns is-align-items-center" @click="setMenu('castProfile')">
            <div class="column" :class="menu == 'castProfile' ? 'selectedMenu' : ''">プロフィール</div>
          </div>
        </div>

        <div class="sectionwrap">
          <div class="columns is-align-items-center" @click="setMenu('liveSchedule')">
            <div class="column" :class="menu == 'liveSchedule' || menu == 'liveScheduleRegistration' || menu == 'liveScheduleUpdate' ? 'selectedMenu' : ''">配信予定管理</div>
          </div>
        </div>

        <div class="sectionwrap">
          <div class="columns is-align-items-center" @click="setMenu('liveMenu')">
            <div class="column" :class="menu == 'liveMenu' ? 'selectedMenu' : ''">配信方法について</div>
          </div>
        </div>

        <div v-if="idProviderHasPassword" class="sectionwrap" @click="setMenu('profilePasswordReset')">
          <div class="columns is-align-items-center">
            <div class="column" :class="menu == 'profilePasswordReset' ? 'selectedMenu' : ''">パスワード再設定</div>
          </div>
        </div>
      </div>
    </div>
    <div class="page">
      <component v-bind:is="currentPage" @action="componentAction" :values="values"></component>
    </div>
  </div>
</template>

<script>
import CastProfile from '@/pages/CastProfile';
import LiveSchedule from '@/pages/LiveSchedule';
import LiveScheduleRegistration from '@/pages/LiveScheduleRegistration';
import LiveScheduleUpdate from '@/pages/LiveScheduleUpdate';
import LiveMenu from '@/pages/LiveMenu';
import ProfilePasswordReset from '@/pages/ProfilePasswordReset';

export default {
  name: 'CastMyPage',
  props: {
    menu: { type: String, default: "castProfile" },
  },
  components: {
    CastProfile,
    LiveSchedule,
    LiveScheduleRegistration,
    LiveScheduleUpdate,
    LiveMenu,
    ProfilePasswordReset
  },
  data() {
    return {
      values: {},
      menus: {
        "castProfile": CastProfile,
        "liveSchedule": LiveSchedule,
        "liveScheduleRegistration": LiveScheduleRegistration,
        "liveScheduleUpdate": LiveScheduleUpdate,
        "liveMenu": LiveMenu,
        "profilePasswordReset": ProfilePasswordReset
      }
    };
  },
  computed: {
    currentPage() {
      return this.menus[this.menu];
    },
    idProviderHasPassword() {
      return this.$store.state.auth.idProviders.includes('password');
    }
  },
  methods: {
    setMenu(menuName) {
      this.$router.push('/cast/mypage/' + menuName);
    },
    componentAction(event) {
      if (event.menu) {
        this.setMenu(event.menu);
        return;
      }

      if (event.mode) {
        if (event.mode === "registration") {
          this.setMenu("liveScheduleRegistration");
        }

        if (event.mode === "update" && event.liveId) {
          this.values["liveId"] = event.liveId;
          this.setMenu("liveScheduleUpdate");
        }
        return;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/mypage.scss';
</style>
